import { render, staticRenderFns } from "./VerificationModal.vue?vue&type=template&id=241ea918"
import script from "./VerificationModal.vue?vue&type=script&lang=js"
export * from "./VerificationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports